// FAQ Accordion Functionality
document.addEventListener('DOMContentLoaded', function() {
  const faqItems = document.querySelectorAll('.faq-item');
  
  // SVG icons
  const minusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z"
      fill="#B2B2C8" />
  </svg>`;
  
  const plusIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H13V5Z"
      fill="#3D8AFC" />
  </svg>`;
  
  faqItems.forEach(item => {
    // Make the entire item clickable
    item.style.cursor = 'pointer';
    
    const iconContainer = item.querySelector('.faq-icon');
    
    // Set initial icon based on expanded state
    if (item.classList.contains('expanded')) {
      iconContainer.innerHTML = minusIcon;
    } else {
      iconContainer.innerHTML = plusIcon;
    }
    
    item.addEventListener('click', function(e) {
      // Toggle the expanded class
      const isExpanded = this.classList.contains('expanded');
      
      if (isExpanded) {
        // Collapse the item
        this.classList.remove('expanded');
        iconContainer.innerHTML = plusIcon;
      } else {
        // Expand the item
        this.classList.add('expanded');
        iconContainer.innerHTML = minusIcon;
      }
    });
  });
});
